import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { IdpAggregateMeteringItem } from '../../models/idpMeteringAggregate';
import { TenantService } from '../tenant-id/tenant.service';

@Injectable({
  providedIn: 'root'
})
export class IdpMeteringAggregateService {
  private http = inject(HttpClient);
  private authService = inject(AuthService);
  private tenantService = inject(TenantService);

  private baseUrl = environment.urls.autoclassifierApi;

  /**
   *
   * @param startDate
   * @param endDate
   */
  getAggregateMeteringData(
    startDate: string,
    endDate: string
  ): Observable<IdpAggregateMeteringItem> {
    const authToken = this.authService.getAuthToken();
    const tenantId = this.tenantService.getTenantId();

    const headers = new HttpHeaders({
      Authorization: `Bearer ${authToken}`,
      tenantId: tenantId
    });

    const params = new HttpParams().set('startDate', startDate).set('endDate', endDate);

    const url = `${this.baseUrl}/idpmeterings/aggregate`;

    return this.http.get<IdpAggregateMeteringItem>(url, { headers, params }).pipe(
      catchError(error => {
        console.error('Error fetching aggregate metering data:', error);
        return throwError(() => error);
      })
    );
  }
}
